import React from 'react'
import { HeaderData } from './ReturnsCreateReturn'
import { Chip } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { ViewItem } from '../ViewItem/ViewItem'
import { utcToLocal } from '../../utils/dateHelper'

interface CreateReturnHeaderProps {
  headerData: HeaderData
}

export const CreateReturnHeader: React.FC<CreateReturnHeaderProps> = ({
  headerData
}) => {
  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 6, sm: 2 }}>
        <ViewItem dense title='OT' text={headerData.workOrderId.toString()} />
      </Grid>
      <Grid size={{ xs: 6, sm: 2 }}>
        <ViewItem
          dense
          title='Despacho'
          text={utcToLocal(headerData.dispatchedDate, 'dd/MM/yyyy HH:mm:ss')}
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 2 }}>
        <ViewItem
          dense
          title='Unidades'
          text={headerData.totalUnits.toString()}
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 3 }}>
        <ViewItem dense title='SKUs' text={headerData.skuQuantity.toString()} />
      </Grid>
      <Grid size={{ xs: 6, sm: 3 }}>
        <ViewItem dense title='IDs de Pedido' text={''} />
        {headerData.externalOrderId.map((order) => (
          <Chip color='default' key={order} label={order} />
        ))}
      </Grid>
    </Grid>
  )
}
